export default "__VITE_ASSET__3cf2531d__"